import React from 'react';
import PeriodListFunctional from './components/periods-list-functional';

const PeriodList = () => {
	return <PeriodListFunctional />;
};

export default PeriodList;
